TS.ns('WL');

WL.approvalTypeModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) { 
        var me = this;

        me.parent(config);

        levelList = me.getDomainProperty('dgLevelCollection_Property');
        if (levelList != null) {
            levelList.on('cellBeginEdit', me.onLevelGridBeginEdit);
        }
         
        userLevelList = me.getDomainProperty('dgUserLevel_Property');
        if (userLevelList != null) {
            userLevelList.on('cellValueChanged', me.onUserLevelGridChanged);
        }
    }, 

    onLevelGridBeginEdit: function (e) { 
        var me = this,
            owner = me._getOwner();
         
        if (e.fieldName == 'DefaultEmployeeName')
            e.preventDefault(); 
    },  

    onUserLevelGridChanged: function (e) { 
        var me = this,
            owner = me._getOwner();

        //levelList = owner.getDomainProperty('dgLevelCollection_Property');
        //userLevelList = owner.getDomainProperty('dgUserLevel_Property');

        if (e.fieldName == 'IsDefault' && userLevelList.SelectedItem().IsDefault()) {

            owner.performServerCommand({ 
                cmd: 'UpdateDefaultEmployeeName',
                submitModel: true,
                blockUI: true,
                extraData: {
                    rowIdx: e.rowIdx,
                    ApprovalTypeLevelId: levelList.SelectedItem().ApprovalTypeLevelId(),
                    DefaultEmployeeName: userLevelList.SelectedItem().EmployeeName(),
                },
            });
        }
    }
});